import { Banner } from '@sequencehq/core-components'
import { useAmendmentLock } from 'modules/Cube/domain/selectors/useAmendmentLock'
import {
  ScheduleAmendmentLockMessage,
  useScheduleAmendmentLock
} from 'common/components/ScheduleAmendmentLock'

/**
 * Says why the editor is read only. The controls are already switched off by
 * available features - without this the schedule would just look inexplicably
 * frozen.
 */
export const AmendmentLockBanner = () => {
  const { lockedByQuoteId } = useAmendmentLock()
  const amendmentLock = useScheduleAmendmentLock(lockedByQuoteId)

  if (!amendmentLock.isLocked) {
    return null
  }

  return (
    <Banner variant="warning" data-testid="schedule.amendmentLockBanner">
      <ScheduleAmendmentLockMessage
        action="edited"
        lock={amendmentLock}
        data-testid="schedule.amendmentLockBanner.message"
      />
    </Banner>
  )
}
